import React from "react";
import { useNavigate } from "react-router-dom";

const LandingPageComp = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/login');
  };

  return (
    <section className="relative isolate flex min-h-[min(680px,calc(100vh-4rem))] items-center overflow-hidden border-b border-line bg-surface-950">
      <div aria-hidden="true" className="absolute inset-0 bg-landing-bg bg-cover bg-center opacity-20" />
      <div aria-hidden="true" className="absolute inset-0 bg-surface-950/80" />


      <div className="relative mx-auto w-full max-w-7xl px-5 py-16 sm:px-8 sm:py-20 lg:px-10">
        <div className="max-w-3xl">
          <span className="eyebrow-accent inline-flex items-center gap-2 rounded-full border border-accent/30 bg-accent/10 px-3 py-1.5">
            <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-accent" />
            THE HOME OF SPORT & ENTERTAINMENT
          </span>
          <h1 className="mt-6 text-4xl font-bold leading-[1.1] tracking-tight text-white sm:text-5xl lg:text-6xl">
            Your world of stories, sport, and competition.
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-7 text-gray-300 sm:text-lg">
            Discover live sports updates, compelling stories, game shows, and competitions—all in one place.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <button
              className="btn-primary group gap-2 px-5 py-3"
              onClick={handleGetStarted}
            >
              Get started
              <svg aria-hidden="true" className="h-4 w-4 transition-transform group-hover:translate-x-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 12h14m-7-7 7 7-7 7" />
              </svg>
            </button>
            <button
              type="button"
              onClick={() => navigate('/sports')}
              className="btn-secondary px-5 py-3"
            >
              Explore sports
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingPageComp;
